module.exports = __webpack_public_path__ + "img/undo.b10acb63.svg";